<template>
  <!-- falta el metodo updateDescription, terminarlo -->
  <div id="card-description" class="card-description">
    <AppSeparator class="card-window__separator" />
    <div class="card-description__heading">
      <SectionHeading icon="far fa-align-left">
        {{ $t('card_modal.sections.description') }}
      </SectionHeading>
      <AppButton v-allowed:employee @click="toggleMarkdownEditor"> Editar </AppButton>
    </div>
    <!-- marked description -->
    <MarkdownMarkedText :text="descriptionText" />
    <!-- markdown editor -->
    <MarkdownEditor
      floating
      placeholder="Añadir descripción detallada..."
      :to-parse="description"
      :show-editor="isEditorOpen"
      @edited="updateDescription"
      @canceled="toggleMarkdownEditor"
    />
    <!-- expand description button -->
    <span v-if="!expanded" @click="toggleExpandedState" class="card-description__expand">
      {{ $t('card_modal.ui.show_full_description') }}
    </span>
  </div>
</template>

<script>
// Utitlities
import { checkApiResponse } from 'Utils'
// Components
import AppButton from 'Ui/AppButton'
import AppSeparator from 'Ui/AppSeparator'
import SectionHeading from 'Components/SectionHeading'
import MarkdownEditor from 'Components/Markdown/MarkdownEditor'
import MarkdownMarkedText from 'Components/Markdown/MarkdownMarkedText'

export default {
  name: 'CardModalDescription',

  components: {
    AppButton,
    AppSeparator,
    MarkdownEditor,
    SectionHeading,
    MarkdownMarkedText,
  },

  props: {
    description: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      expanded: false,
      initialLength: 422,
      isEditorOpen: false,
    }
  },

  methods: {
    toggleMarkdownEditor() {
      this.isEditorOpen = !this.isEditorOpen
    },

    toggleExpandedState() {
      this.expanded = !this.expanded
    },

    async updateDescription(editedDescription) {
      const cardInfo = {
        id: this.$route.params.card_id,
        newValues: {
          description: editedDescription,
        },
      }
      const update = await this.$store.dispatch('cards/updateCard', cardInfo)
      if (!checkApiResponse(update)) return
      this.toggleMarkdownEditor()
    },
  },

  computed: {
    isEmployee() {
      return this.userType === 'EMPLOYEE'
    },

    shortenedDescription() {
      // begin
      let result

      if (this.description.length > this.initialLength) {
        const shortened = this.description.slice(0, this.initialLength)
        // nos aseguramos no cortar ninguna línea
        result = shortened.slice(0, shortened.lastIndexOf('\n'))
      } else {
        result = this.description
        this.toggleExpandedState()
      }
      return result
    },

    descriptionText() {
      return this.expanded ? this.description : this.shortenedDescription
    },
  },
}
</script>

<style scoped>
.card-description__heading {
  display: flex;
  align-content: center;
  justify-content: flex-start;
}

.card-description__heading .app-button {
  font-size: 12px;
  line-height: 10px;
  width: auto;
  min-height: 30px;
  padding: 6px 12px;
}

.card-description__expand {
  display: inline-block;
  position: relative;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  width: 100%;
  color: var(--c-primary);
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 -30px 15px 4px rgb(244 244 250 / 88%);
}

.card-description >>> .markdown__editor-draft .app-textarea {
  min-height: 350px;
}

@media (max-width: 680px) {
  .card-description >>> .markdown__marked-text {
    max-width: unset;
  }
}
</style>
